export default "__VITE_ASSET__BLT7XuCg__"